var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
/**
 * Represents the sparkline chart
 */
let DinapsisChip = class DinapsisChip extends LitElement {
    constructor() {
        super();
        /**
         * A property that is used to generate unique idChip
         */
        this.idChip = '';
        this.model = {
            style: 'regular',
            text: '',
            icon: '',
            image: '',
            tabindex: '0',
            disabled: false,
            selected: false,
            canSelect: true,
            canRemove: false,
        };
    }
    createRenderRoot() {
        return this;
    }
    /**
     * This method creates a icon for the user interface.
     *
     * @returns {string} - The HTML string for the icon, or an empty string if not set
     */
    createIcon() {
        if (this.model.icon) {
            return html `<span class="material-icons">${this.model.icon}</span>`;
        }
        if (this.model.image) {
            return html `<img class="imagen" src="${this.model.image}"/>`;
        }
        return '';
    }
    /**
     * This method changes the selected button in the user interface and calls tableModeActive().
     * @param {any} evt - The event that triggered the method.
     * @returns {void}
     */
    clickChip(evt) {
        if (this.model.canSelect) {
            const divChip = evt.currentTarget;
            if (divChip.classList.contains('activated')) {
                divChip.classList.remove('activated');
            }
            else {
                divChip.classList.add('activated');
            }
            this.dispatchEvent(new CustomEvent('click-chip', { detail: { model: this.model, divId: this.idChip } }));
        }
    }
    /**
     * This method creates a delete icon for the user interface.
     *
     * @returns {string} - The HTML string for the delete icon, or an empty string if not set
     */
    createDeleteIcon() {
        if (this.model.canRemove) {
            return html `
      <div @click="${() => this.dispatchEvent(new CustomEvent('remove-chip', { detail: this.model.id }))}">
        <span class="material-icons btn-cancel">cancel</span>
      </div>`;
        }
        return '';
    }
    /**
     * This method adds style according to your configuration.
     *
     * @returns {string} - The string whit style class, or an empty string
     */
    createClass() {
        let className = 'chip-text';
        if (!this.model.canRemove) {
            className += ' chip-text__large-right';
        }
        if (!this.model.icon && !this.model.image) {
            className += ' chip-text__large-left';
        }
        return className;
    }
    /**
     * If any property has changed when finish update this method is called an
     * depending on wich property has been modified,
     * it executes its update method
     * @param changedProperties - Map<string, unknown>
     */
    updated(changedProperties) {
        if (changedProperties.has('model')) {
            const div = document.querySelector(`#${this.idChip}`);
            if (div) {
                if (this.model.disabled) {
                    div.classList.add('disable');
                }
                if (this.model.selected) {
                    div.classList.add('activated');
                }
                else {
                    div.classList.remove('activated');
                }
            }
        }
    }
    /**
     * The above function is a lifecycle hook that is called when the component is first updated.
     * It is used to initialize chip.
     */
    firstUpdated() {
        const div = document.querySelector(`#${this.idChip}`);
        if (div) {
            if (this.model.disabled) {
                div.classList.add('disable');
            }
            if (this.model.selected) {
                div.classList.add('activated');
            }
        }
    }
    render() {
        this.idChip = `chipdiv-${this.model.id}`;
        return html `
      <div class="chip ${this.model.style}" id="${this.idChip}" @click="${this.clickChip}" tabindex="${this.model.tabindex}">
        ${this.createIcon()}
        <span class="${this.createClass()}" title="${this.model.text}">${this.model.text}</span>
        ${this.createDeleteIcon()}
      </div>
    `;
    }
};
__decorate([
    property()
], DinapsisChip.prototype, "model", void 0);
DinapsisChip = __decorate([
    customElement('dinapsis-chip')
], DinapsisChip);
export { DinapsisChip };
//# sourceMappingURL=dinapsis-chip.js.map